import { useAppSelector } from '@shared/store';
import { selectStreamLibraryId } from '@entities/account';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountCompanyStreamLibraryId = () => {
  const selectors = useAccountSelectors();

  const streamLibraryId = useAppSelector(selectors.selectCompanyStreamLibraryId);
  const streamLibraryIdFallback = useAppSelector(selectStreamLibraryId);

  return streamLibraryId || streamLibraryIdFallback;
};
